@for (toast of toastService.toasts(); track toast.id) {
  <lib-toast
    [title]="toast.title"
    [message]="toast.message"
    [type]="toast.type"
    [dismissible]="toast.dismissible"
    [duration]="toast.duration"
    (dismissed)="toastService.dismiss(toast.id)"
  />
}
